<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{$t('perfil')}}
                        </li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">

                <div class="card">
                    <div class="row">

                        <div class="col-md-6">

                            <div class="col-md-12">
                                <h4>{{$t('datosPersonales')}}</h4>
                                <hr>
                            </div>

                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="nombre"><strong>{{$t('nombre')}}</strong>*</label>
                                    <input v-model="perfil.nombre" type="text" class="form-control"
                                           id="nombre" placeholder="Nombre">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="apellidos"><strong>{{$t('apellidos')}}</strong>*</label>
                                    <input v-model="perfil.apellidos" type="text" class="form-control"
                                           id="apellidos" placeholder="Apellidos">
                                </div>
                            </div>


                        </div>

                        <div class="col-md-6">

                            <div class="col-md-12">
                                <h4>{{$t('datosDeAcceso')}}</h4>
                                <hr>
                            </div>
                            <div class="col-md-12">

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="email"><strong>{{$t('email')}}</strong>*</label>
                                        <input v-model="perfil.email" type="text" class="form-control"
                                               id="email" placeholder="Email">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="contrasenyaAntigua"><strong>{{$t('contrasenaAntigua')}}</strong></label>
                                        <input type="password" v-model="perfil.contrasenyaAntigua" class="form-control"
                                               id="contrasenyaAntigua" :placeholder="$t('contrasenaAntigua')">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="contrasenyaNueva"><strong>{{$t('contrasenaNueva')}}</strong></label>
                                        <input v-model="perfil.contrasenyaNueva" type="password" class="form-control"
                                               id="contrasenyaNueva" :placeholder="$t('contrasenaNueva')">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="confirmarContrasenya"><strong>{{$t('confirmarContrasena')}}</strong></label>
                                        <input v-model="perfil.contrasenyaConfirm" type="password" class="form-control"
                                               id="confirmarContrasenya" :placeholder="$t('confirmarContrasena')">
                                    </div>
                                </div>

                                <div class="col-md-12 text-right">

                                    <p style="font-size: 15px"><i class="fas fa-user-plus text-success"></i> <a href="https://www.numier.com/altas/">{{$t('quieresDarDeAltaUnUsuario')}}</a></p>
                                    <p style="font-size: 15px"><i class="fas fa-user-minus text-danger"></i> <a href="https://www.numier.com/bajas/">{{$t('quieresDarDeBajaUnUsuario')}}</a></p>

                                    <button @click="editPerfil()" class="btn btn-primary"><i
                                            class="fa fa-check-square"></i> {{$t("guardar")}}
                                    </button>

                                </div>

                            </div>
                        </div>

                        <div class="col-md-12" v-if="!esSelfi">

                            <div class="col-md-12">
                                <h4>{{$t('licencias')}}</h4>
                                <hr>
                            </div>

                            <div class="table-responsive">
                                <table class="table table-bordered table-striped">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th>{{$t('nombreTpv')}}</th>
                                        <th>{{$t('estado')}}</th>
                                        <th>{{$t('fechaCaducidad')}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="licencia in listLicencias">
                                        <td>{{licencia.nameShow}}</td>
                                        <td><strong
                                                :class="licencia.estado==='Online' ? 'text-success' : 'text-danger'">{{licencia.estado}}</strong>
                                        </td>
                                        <td>
                                            <template v-if="licencia.expiryDateOnline==='0'">{{$t('ilimitado')}}</template>
                                            <template v-else>{{licencia.expiryDateOnline | parseDate}}</template>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>


</template>

<script>
    import swal from 'sweetalert2'
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        Switch
    } from 'element-ui'

    export default {
        name: "Perfil",
        created() {

            this.getPerfil();
            this.checkIsSelfi();

        },
        data() {
            return {

                perfil: {

                    nombre: "",
                    apellidos: "",
                    email: "",
                    contrasenyaAntigua: "",
                    contrasenyaNueva: "",
                    contrasenyaConfirm: "",

                },
                listLicencias: [],
                esSelfi : false,
            }
        },
        methods: {
            checkIsSelfi() {
                let vm = this;

                const esSelfiCookie = document.cookie
                    .split("; ")
                    .find((row) => row.startsWith("esSelfi="));

                // Verificar si la cookie existe antes de intentar acceder a su valor
                if (esSelfiCookie) {
                    vm.esSelfi = esSelfiCookie.split("=")[1];
                } else {
                    vm.esSelfi = false;
                }
            },
            getPerfil() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'general/getPerfil', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.perfil.nombre = response.data.result.perfil.firstName;
                            vm.perfil.apellidos = response.data.result.perfil.surName;
                            vm.perfil.email = response.data.result.perfil.email;
                            vm.perfil.language = response.data.result.perfil.language;
                            vm.listLicencias = response.data.result.licencias;


                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },

            editPerfil() {
                let vm = this;
                if (this.perfil.nombre === "" || this.perfil.apellidos === "" || this.perfil.email === "") {

                    swal({
                        title: vm.$t('atencion'),
                        text: vm.$t('relleneLosCamposObligatorios'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });


                }
                else if (this.perfil.contrasenyaAntigua === '' && this.perfil.contrasenyaNueva === '' && this.perfil.contrasenyaConfirm === '') {

                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt,
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        jwt: this.$store.getters.jwt,
                        perfil: this.perfil
                    };

                    let vm = this;
                    let controller = "editPerfil";
                    this.axios.post(this.$store.getters.apiUrl + 'general/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {
                                let notify = vm.$t('actualizado');
                                vm.$notify({
                                    message: vm.$t('perfil')+ ' ' + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });

                }
                else if ((this.perfil.contrasenyaNueva === this.perfil.contrasenyaConfirm) && this.perfil.contrasenyaAntigua !== '') {

                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt,
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        jwt: this.$store.getters.jwt,
                        perfil: this.perfil
                    };

                    let vm = this;
                    let controller = "editPerfil";
                    this.axios.post(this.$store.getters.apiUrl + 'general/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {
                                let notify = vm.$t('actualizado');
                                vm.$notify({
                                    message: vm.$t('perfil')+ ' ' + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });


                }
                else {

                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('lasContrasenasNoCoinciden'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }


            }

        }

    }
</script>

<style scoped>

    .card {
        padding: 20px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Perfil/Perfil.vue